import { routes } from '../../../routes/mainRoutes';

const getAuthFormTitle = ({ matchUrl, language }) =>
  matchUrl === routes.REGISTER
    ? language.authForm.signupTitle
    : matchUrl === routes.LOGIN
    ? language.authForm.signinTitle
    : matchUrl === routes.SEND_EMAIL
    ? language.authForm.sendEmailTitle
    : language.authForm.newPasswordTitle;

export { getAuthFormTitle };
